import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

/**
 * Optional action buttons rendered on the right side of the tab header row.
 * Configure via `props.actions` on the tabs field.
 */
export interface TabsAction {
	label: string;
	icon?: string;
	color?: 'primary' | 'accent' | 'warn';
	onClick?: (field: FormlyFieldConfig) => void;
}

@Component({
	selector: 'formly-field-tabs',
	template: `
		<div class="formly-tabs">
			<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
				<mat-tab *ngFor="let tab of visibleTabs" [label]="tab.props.label">
					<formly-field [field]="tab"></formly-field>
				</mat-tab>
			</mat-tab-group>
			<div class="formly-tabs__actions" *ngIf="actions.length">
				<button
					*ngFor="let action of actions"
					mat-button
					type="button"
					[color]="action.color ?? 'warn'"
					(click)="action.onClick?.(field)"
				>
					<mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
					{{ action.label }}
				</button>
			</div>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.formly-tabs {
				position: relative;
			}
			/* Vertically centred within the 48px mat-tab header row */
			.formly-tabs__actions {
				position: absolute;
				top: 6px;
				right: 0;
				display: flex;
				gap: 4px;
			}
		`,
	],
	imports: [MatTabGroup, NgFor, MatTab, FormlyModule, NgIf, MatButton, MatIcon],
})
export class FormlyFieldTabs extends FieldType {
	get actions(): TabsAction[] {
		return this.props['actions'] ?? [];
	}

	/**
	 * Get visible tabs (filter out hidden tabs)
	 */
	get visibleTabs(): FormlyFieldConfig[] {
		return this.field.fieldGroup?.filter((tab) => !tab.hide) ?? [];
	}
}
